function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { fromDateStampObject } from "../../../../../models/time/translator";
import { BillingScheduleGroupType } from "../../../../../types/api/relationship/billingSchedule.model";
import { formatLongMonthDateWithLocalTimezone } from "../../../../../utils/date-formatting";
import { pluralize } from "../../../../../utils/pluralize";
const formatServiceNotes = function formatServiceNotes(service) {
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const notes = [];
  if (context.isToday && service.priorPeriods && service.priorPeriods > 0 && service.priorPeriodsTotal) {
    const priorPeriodsCount = service.priorPeriods;
    notes.push("Includes ".concat(priorPeriodsCount, " prior ").concat(priorPeriodsCount === 1 ? 'period' : 'periods'));
  }
  if (service.isProrated) {
    notes.push('First payment is prorated');
  }
  if (service.billingStages) {
    notes.push("Stage ".concat(service.billingStages.stageNumber, "/").concat(service.billingStages.totalStages));
  }
  if (service.remainingCharges) {
    notes.push("Billed ".concat(pluralize('time', service.remainingCharges, true)));
  }
  return notes;
};
const translateService = function translateService(service) {
  var _service$priorPeriods, _service$remainingCha;
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    serviceId: service.serviceId,
    name: service.name,
    price: (service.priorPeriodsTotal || service.price) / 100,
    priorPeriods: (_service$priorPeriods = service.priorPeriods) !== null && _service$priorPeriods !== void 0 ? _service$priorPeriods : null,
    remainingCharges: (_service$remainingCha = service.remainingCharges) !== null && _service$remainingCha !== void 0 ? _service$remainingCha : null,
    notes: formatServiceNotes(service, context)
  };
};
const formatFrequencyLabel = type => {
  switch (type) {
    case BillingScheduleGroupType.Weekly:
      return 'weekly';
    case BillingScheduleGroupType.Biweekly:
      return 'every two weeks';
    case BillingScheduleGroupType.Monthly:
      return 'monthly';
    case BillingScheduleGroupType.Quarterly:
      return 'quarterly';
    case BillingScheduleGroupType.Yearly:
      return 'yearly';
    default:
      return '';
  }
};
const formatDayOfMonth = dayOfMonth => {
  if (!dayOfMonth) return '';
  if (dayOfMonth.type === 'lastDayOfMonth') {
    return 'on the last day of the month';
  }
  if (dayOfMonth.dayOfMonth) {
    const day = dayOfMonth.dayOfMonth.day;
    if (day === 1) return 'on the 1st';
    if (day === 2) return 'on the 2nd';
    if (day === 3) return 'on the 3rd';
    if (day >= 4 && day <= 20) return "on the ".concat(day, "th");
    if (day === 21) return 'on the 21st';
    if (day === 22) return 'on the 22nd';
    if (day === 23) return 'on the 23rd';
    if (day >= 24 && day <= 30) return "on the ".concat(day, "th");
    if (day === 31) return 'on the 31st';
    return "on the ".concat(day);
  }
  return '';
};
const formatQuarterlyDay = (billingOnDay, lastDayOfPeriod) => {
  if (lastDayOfPeriod) {
    return 'on the last day of the quarter';
  }
  if (billingOnDay === 0) {
    return 'on the first day of the quarter';
  }
  return "on day ".concat(billingOnDay, " of the quarter");
};
export const translateBillingSchedule = billingSchedule => {
  const sections = [];
  for (const group of billingSchedule.groups) {
    switch (group.type) {
      case BillingScheduleGroupType.Today:
        {
          const services = group.today.services.map(service => translateService(service, {
            isToday: true
          }));
          sections.push({
            title: 'Billed today',
            totalAmount: group.today.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.OnRelationshipEffectiveDate:
        {
          const effectiveDate = fromDateStampObject(group.onRelationshipEffectiveDate.effectiveDate);
          const formattedDate = formatLongMonthDateWithLocalTimezone(effectiveDate);
          const {
            isFuture
          } = group.onRelationshipEffectiveDate;
          if (isFuture) {
            const services = group.onRelationshipEffectiveDate.services.map(service => translateService(service, {
              isEffectiveDate: true
            }));
            sections.push({
              title: "Billed on ".concat(formattedDate),
              totalAmount: group.onRelationshipEffectiveDate.totalAmount / 100,
              services
            });
          }
          break;
        }
      case BillingScheduleGroupType.BilledOnStages:
        {
          const services = group.billedOnStages.services.map(service => translateService(service));
          sections.push({
            title: 'Billed in stages',
            totalAmount: group.billedOnStages.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.Weekly:
        {
          const frequency = formatFrequencyLabel(group.type);
          const dayOfWeek = group.weekly.billingOnDayOfWeek;
          const effectiveDate = fromDateStampObject(group.weekly.effectiveDate);
          const formattedDate = formatLongMonthDateWithLocalTimezone(effectiveDate);
          const {
            isFuture
          } = group.weekly;
          const services = group.weekly.services.map(service => translateService(service));
          const title = isFuture ? "Billed ".concat(frequency, " on ").concat(dayOfWeek, ", starting on ").concat(formattedDate) : "Billed ".concat(frequency, " on ").concat(dayOfWeek);
          sections.push({
            title,
            totalAmount: group.weekly.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.Biweekly:
        {
          const frequency = formatFrequencyLabel(group.type);
          const dayOfWeek = group.biweekly.billingOnDayOfWeek;
          const effectiveDate = fromDateStampObject(group.biweekly.effectiveDate);
          const formattedDate = formatLongMonthDateWithLocalTimezone(effectiveDate);
          const {
            isFuture
          } = group.biweekly;
          const services = group.biweekly.services.map(service => translateService(service));
          const title = isFuture ? "Billed ".concat(frequency, " on ").concat(dayOfWeek, ", starting on ").concat(formattedDate) : "Billed ".concat(frequency, " on ").concat(dayOfWeek);
          sections.push({
            title,
            totalAmount: group.biweekly.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.Monthly:
        {
          const frequency = formatFrequencyLabel(group.type);
          const dayOfMonthStr = formatDayOfMonth(group.monthly.dayOfMonth);
          const effectiveDate = fromDateStampObject(group.monthly.effectiveDate);
          const formattedDate = formatLongMonthDateWithLocalTimezone(effectiveDate);
          const {
            isFuture
          } = group.monthly;
          const services = group.monthly.services.map(service => translateService(service));
          const title = isFuture ? "Billed ".concat(frequency, " ").concat(dayOfMonthStr, ", starting on ").concat(formattedDate) : "Billed ".concat(frequency, " ").concat(dayOfMonthStr);
          sections.push({
            title: title.trim(),
            totalAmount: group.monthly.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.Quarterly:
        {
          const frequency = formatFrequencyLabel(group.type);
          const dayStr = formatQuarterlyDay(group.quarterly.billingOnDay, group.quarterly.lastDayOfPeriod);
          const effectiveDate = fromDateStampObject(group.quarterly.effectiveDate);
          const formattedDate = formatLongMonthDateWithLocalTimezone(effectiveDate);
          const {
            isFuture
          } = group.quarterly;
          const services = group.quarterly.services.map(service => translateService(service));
          const title = isFuture ? "Billed ".concat(frequency, " ").concat(dayStr, ", starting on ").concat(formattedDate) : "Billed ".concat(frequency, " ").concat(dayStr);
          sections.push({
            title: title.trim(),
            totalAmount: group.quarterly.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.Yearly:
        {
          const frequency = formatFrequencyLabel(group.type);
          const effectiveDate = fromDateStampObject(group.yearly.effectiveDate);
          const formattedDate = formatLongMonthDateWithLocalTimezone(effectiveDate);
          const {
            isFuture
          } = group.yearly;
          const services = group.yearly.services.map(service => translateService(service));
          const title = isFuture ? "Billed ".concat(frequency, ", starting on ").concat(formattedDate) : "Billed ".concat(frequency);
          sections.push({
            title: title.trim(),
            totalAmount: group.yearly.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.Paused:
        {
          const services = group.paused.services.map(service => translateService(service));
          sections.push({
            title: 'Billed monthly upon activation',
            totalAmount: group.paused.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.WeeklyPaused:
        {
          const services = group.paused.services.map(service => translateService(service));
          sections.push({
            title: 'Billed weekly upon activation',
            totalAmount: group.paused.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.BiweeklyPaused:
        {
          const services = group.paused.services.map(service => translateService(service));
          sections.push({
            title: 'Billed biweekly upon activation',
            totalAmount: group.paused.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.MonthlyPaused:
        {
          const services = group.paused.services.map(service => translateService(service));
          sections.push({
            title: 'Billed monthly upon activation',
            totalAmount: group.paused.totalAmount / 100,
            services
          });
          break;
        }
      case BillingScheduleGroupType.QuarterlyPaused:
        {
          const services = group.paused.services.map(service => translateService(service));
          sections.push({
            title: 'Billed quarterly upon activation',
            totalAmount: group.paused.totalAmount / 100,
            services
          });
          break;
        }
    }
  }
  const combinedSections = new Map();
  const sectionOrder = [];
  for (const section of sections) {
    const existing = combinedSections.get(section.title);
    if (existing) {
      existing.totalAmount += section.totalAmount;
      existing.services.push(...section.services);
    } else {
      combinedSections.set(section.title, _objectSpread({}, section));
      sectionOrder.push(section.title);
    }
  }
  const orderedSections = sectionOrder.map(title => combinedSections.get(title));
  return {
    sections: orderedSections
  };
};